import { ElementType, GlobalConfig } from "../types/builder";

const generateId = (): string => {
  return Math.random().toString(36).substr(2, 9);
};

const createContactUsSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    padding: "67px 0",
    backgroundColor: "background",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  responsiveStyles: {
    tablet: { padding: "30px 0" },
    mobile: { padding: "20px 0" },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "1200px",
        margin: "0 auto",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "77px 0",
      },
      responsiveStyles: {
        tablet: { gap: "40px 0" },
        mobile: { gap: "24px 0" },
      },
      children: [
        // Header
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 0,
          },
          children: [
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: "Contact us",
              styles: {
                color: "#000",
                textAlign: "center",
                fontFamily: "Roboto, sans-serif",
                fontSize: "70px",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "90%",
                letterSpacing: "-2.1px",
                margin: 0,
              },
              responsiveStyles: {
                tablet: { fontSize: "50px" },
                mobile: { fontSize: "44px" },
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content: "We're here to help - reach out any time.",
              styles: {
                color: "#000",
                textAlign: "center",
                fontFamily: "Poppins, sans-serif",
                fontSize: "28px",
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "80px",
                letterSpacing: "-0.84px",
                margin: 0,
              },
              responsiveStyles: {
                tablet: { fontSize: "20px", lineHeight: "50px" },
                mobile: { fontSize: "16px", lineHeight: "40px" },
              },
            },
          ],
        },
        // Cards
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            gap: "70px",
            width: "100%",
          },
          responsiveStyles: {
            tablet: { maxWidth: "95%", margin: "0 auto", gap: "35px" },
            mobile: {
              maxWidth: "95%",
              margin: "0 auto",
              flexDirection: "column",
              gap: "20px",
            },
          },
          children: [
            // Product Email Support Card
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                flex: "0 0 calc(50% - 35px)",
                borderRadius: "28px",
                backgroundColor: "primary",
                padding: "20px 30px",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "320px",
              },
              responsiveStyles: {
                tablet: { padding: "16px" },
                mobile: {
                  maxWidth: "400px",
                  minHeight: "290px",
                  width: "100%",
                },
              },
              children: [
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "12px",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/fortigold/card1ContactUs.svg",
                      alt: "Product Email Support",
                      styles: {
                        width: "35px",
                        height: "40px",
                        objectFit: "contain",
                      },
                      responsiveStyles: {
                        mobile: { width: "30px", height: "30px" },
                      },
                    },
                    {
                      id: generateId(),
                      type: "heading" as ElementType,
                      content: "Product Email Support",
                      styles: {
                        color: "#FBBC04",
                        textAlign: "center",
                        fontFamily: "Poppins, sans-serif",
                        fontSize: "36px",
                        fontStyle: "normal",
                        fontWeight: 700,
                        lineHeight: "70px",
                        letterSpacing: "-1.2px",
                        margin: 0,
                      },
                      responsiveStyles: {
                        tablet: { fontSize: "26px", lineHeight: "50px" },
                        mobile: { fontSize: "20px", lineHeight: "40px" },
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "link" as ElementType,
                  content: "support@fortigold.com",
                  href: "mailto:support@fortigold.com",
                  styles: {
                    color: "#FFF",
                    textAlign: "center",
                    fontFamily: "Poppins, sans-serif",
                    fontSize: "28px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "80px",
                    letterSpacing: "-0.84px",
                    textDecoration: "underline",
                    margin: 0,
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "20px" },
                  },
                },
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content: "*Our team usually responds within a few hours.",
                  styles: {
                    marginTop: "45px",
                    color: "#FFF",
                    textAlign: "center",
                    fontFamily: "Poppins, sans-serif",
                    fontSize: "20px",
                    fontStyle: "normal",
                    fontWeight: 300,
                    lineHeight: "100%",
                    letterSpacing: "-0.6px",
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "16px", marginTop: "40px" },
                    mobile: { marginTop: "18px" },
                  },
                },
              ],
            },
            // Live Chat Support Card
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                flex: "0 0 calc(50% - 35px)",
                borderRadius: "28px",
                backgroundColor: "primary",
                padding: "20px 30px",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "320px",
              },
              responsiveStyles: {
                tablet: { padding: "16px" },
                mobile: {
                  maxWidth: "400px",
                  minHeight: "290px",
                  width: "100%",
                },
              },
              children: [
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "12px",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/fortigold/card2ContactUs.svg",
                      alt: "Live Chat Support",
                      styles: {
                        width: "37px",
                        height: "34px",
                        objectFit: "contain",
                      },
                      responsiveStyles: {
                        mobile: { width: "30px", height: "30px" },
                      },
                    },
                    {
                      id: generateId(),
                      type: "heading" as ElementType,
                      content: "Live Chat Support",
                      styles: {
                        color: "#FBBC04",
                        textAlign: "center",
                        fontFamily: "Poppins, sans-serif",
                        fontSize: "36px",
                        fontStyle: "normal",
                        fontWeight: 700,
                        lineHeight: "70px",
                        letterSpacing: "-1.2px",
                        margin: 0,
                      },
                      responsiveStyles: {
                        tablet: { fontSize: "26px", lineHeight: "50px" },
                        mobile: { fontSize: "20px", lineHeight: "40px" },
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content: "24/7 Live Chat Support",
                  styles: {
                    color: "#F7F7F7",
                    textAlign: "center",
                    fontFamily: "Poppins, sans-serif",
                    fontSize: "28px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "100%",
                    letterSpacing: "-0.84px",
                    margin: 0,
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "24px" },
                    mobile: { marginTop: "12px", fontSize: "20px" },
                  },
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    marginTop: "40px",
                    display: "flex",
                    justifyContent: "center",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "link" as ElementType,
                      content: "Start Live Chat",
                      href: "javascript:void(0)",
                      styles: {
                        backgroundImage:
                          "conic-gradient(from 54deg at 42% 100%, #FBBC04 5.4deg, #FED159 196.2deg, #FED159 360deg)",
                        color: "#000",
                        padding: "12px 24px",
                        fontSize: "32px",
                        fontStyle: "normal",
                        fontWeight: 900,
                        letterSpacing: "-0.96px",
                        border: "1px solid #0000001A",
                        display: "inline-block",
                        width: "auto",
                        textAlign: "center",
                        fontFamily: "Roboto, sans-serif",
                        textDecoration: "none",
                        borderRadius: "8px",
                        transition: "all 0.2s cubic-bezier(.4,0,.2,1)",
                      },
                      responsiveStyles: {
                        tablet: { fontSize: "28px" },
                        mobile: { fontSize: "22px" },
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});

const createFortigoldFAQSection = (
  globalConfig: GlobalConfig,
  vslShowHide?: boolean
) => ({
  id: generateId(),
  type: "container" as ElementType,
  vslShowHide: vslShowHide,
  styles: {
    backgroundColor: "background",
    padding: "80px 0",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    margin: "20px 0",
  },
  responsiveStyles: {
    tablet: { padding: "20px 0" },
    mobile: { padding: "20px 0" },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "1270px",
        margin: "0 auto",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      },
      responsiveStyles: {
        mobile: {
          maxWidth: "100%",
        },
      },
      children: [
        // Section Title
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            textAlign: "center",
            marginBottom: "48px",
            width: "100%",
          },
          responsiveStyles: {
            tablet: { marginBottom: "20px" },
            mobile: { marginBottom: "16px" },
          },
          children: [
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: "Frequently Asked Questions ",
              styles: {
                fontSize: "64px",
                color: "forground",
                opacity: "0.9",
                marginBottom: "15px",
                fontWeight: 900,
                fontFamily: "Roboto, sans-serif",
              },
              responsiveStyles: {
                tablet: { fontSize: "38px" },
                mobile: {
                  fontSize: "38px",
                  lineHeight: "48px",
                  letterSpacing: "-1.14px",
                  marginBottom: "0px",
                },
              },
            },
          ],
        },
        // FAQ Container
        {
          id: generateId(),
          type: "accordion" as ElementType,
          allowMultiple: false,
          defaultOpen: false,
          accordionType: "single" as "single" | "multiple",
          // Icon configuration for all accordion items
          iconSrcCollapsed: "/fortigold/arrow-right-circle.svg",
          iconSrcExpanded: "/fortigold/arrow-right-circle.svg",
          // Icon styling
          iconStyles: {
            width: "46px",
            height: "47px",
            marginLeft: "16px",
          },
          styles: {
            width: "100%",
            margin: "0 auto",
            display: "flex",
            flexDirection: "column",
            border: "0",
          },
          responsiveStyles: {
            tablet: { maxWidth: "95%" },
            mobile: { maxWidth: "100%" },
          },
          children: [
            // FAQ Items
            ...[
              {
                q: "What exactly is FortiGold and how does it work?",
                a: "FortiGold is a premium, doctor-formulated gut health supplement made from first-milking colostrum also known as \"nature's golden liquid.\" It's packed with protective antibodies, growth factors, and over 40x the active nutrients of ordinary supplements. In just one scoop a day, it helps rebuild your gut lining, eliminate toxins, strengthen your immune system, and helps restore your natural energy—starting in just 72 hours.",
              },
              {
                q: "How fast can I expect to feel a difference?",
                a: "Many users report feeling more energy, less bloating, and better digestion in the first 3 days. Most dramatic transformations happen around 3 weeks to 3 months, depending on the level of gut damage. Our research shows FortiGold starts supporting the repair of your gut barrier in as little as 72 hours and keeps getting better from there.",
              },
              {
                q: "Is FortiGold safe to take every day?",
                a: "Absolutely. FortiGold is 100% natural, non-GMO, gluten-free, stimulant-free, and non-habit forming. It's manufactured in an FDA-registered, GMP-certified facility and triple-tested for purity and safety. You can safely take it every day for long-term support.",
              },
              {
                q: "I've tried probiotics and gut supplements before. How is FortiGold different?",
                a: "Probiotics often act like band-aids. FortiGold is the only formula that help seals, heals, and strengthens your gut lining using nature's most complete healing package: immunoglobulins (antibodies), growth factors, and bioavailable nutrients. It's not just relief—it's real, lasting repair.",
              },
              {
                q: "What kind of results are people getting?",
                a: 'Countless people have experienced life-changing transformations: better digestion, more energy, sharper focus, glowing skin, fewer sick days, and renewed confidence. People say things like "my brain fog disappeared," "I finally feel like myself again," and "this saved my life."',
              },
              {
                q: "Will this help with bloating, weight gain, or brain fog?",
                a: "Yes. FortiGold was specifically designed to help eliminate bloating, rebalance metabolism for easier weight loss, and reduce inflammation that causes brain fog and fatigue. When your gut barrier is restored, everything else improves—naturally.",
              },
              {
                q: "What if it doesn't work for me?",
                a: "That's okay. We stand behind FortiGold with a 60-day, 100% money-back guarantee. If you don't see real results—more energy, clearer thinking, better digestion—you can get a full refund. No hassle, no questions asked.",
              },
              {
                q: "How do I take it, and does it taste good?",
                a: "Just one scoop mixed with water, coffee, or a smoothie in the morning. That's it. Most customers say it tastes creamy and smooth, and some even add it to their pancakes or oatmeal like Sarah did in her story.",
              },
              {
                q: "What's the best package to order for full results?",
                a: "The 6-month package is the most popular because it helps give your gut time to fully repair and rebuild its protective barrier. Plus, it comes with free shipping, bonus guides, and a private strategy session. It also gives you the lowest price per bottle—just $49.",
              },
              {
                q: "Why is FortiGold selling out so fast?",
                a: "Because it's backed by real science, it works, and the demand is exploding. Each batch is made with premium colostrum using a cold-filtration process that preserves all healing compounds—which limits supply. Once it's gone, it could take months to restock.",
              },
            ].map((item, idx) => ({
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                padding: "0",
                marginBottom: "32px",
                transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "flex-start",
                flexDirection: "column",
                gap: "32px ",
                width: "100%",
                border: "0",
                position: "relative", // Added for absolute positioned icon
              },
              responsiveStyles: {
                tablet: {
                  marginBottom: "0px",
                  padding: "24px 16px",
                  gap: "24px",
                },
                mobile: {
                  marginBottom: "0px",
                  padding: "6px 16px",
                  gap: "18px",
                },
              },
              children: [
                // Simple question heading
                {
                  id: generateId(),
                  type: "heading" as ElementType,
                  accordionRole: "question" as const,
                  content: item.q,
                  styles: {
                    margin: 0,
                    padding: "0px 24px",
                    border: "1px solid rgba(0,0,0,0.20)",
                    backgroundColor: "#F7F7F7",
                    borderRadius: "16px",
                    height: "100px",
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    cursor: "pointer",
                    fontFamily: "Poppins, sans-serif",
                    fontWeight: 600,
                    fontSize: "32px",
                    color: "#393939",
                  },
                  responsiveStyles: {
                    tablet: {
                      height: "80px",
                      fontSize: "24px",
                    },
                    mobile: {
                      height: "80px",
                      fontSize: "18px",
                      lineHeight: "25px",
                      letterSpacing: "-0.54px",
                    },
                  },
                },
                // Answer element with accordion role
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  accordionRole: "answer" as const,
                  content: item.a,
                  styles: {
                    margin: 0,
                    fontFamily: "Poppins, sans-serif",
                    fontSize: "24px",
                    color: "forground",
                    opacity: "0.6",
                    width: "100%",
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "18px" },
                    mobile: { fontSize: "14px" },
                  },
                },
              ],
            })),
          ],
        },
      ],
    },
  ],
});

const createFooterMenuSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    backgroundColor: "primary",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "100%",
        margin: "0 auto",
        width: "100%",
        display: "flex",
        justifyContent: "center",
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            height: "100px",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            gap: "0 72px",
            width: "100%",
          },
          responsiveStyles: {
            tablet: {
              gap: "0 24px",
            },
            mobile: {
              flexDirection: "column",
              gap: "28px 16px",
              height: "auto",
              padding: "28px 0",
            },
          },
          children: [
            // Privacy
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Privacy",
              href: "/privacy-policy",
              styles: {
                color: "#FFF",
                textAlign: "center",
                fontFamily: "Roboto, sans-serif",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: 900,
                letterSpacing: "-1.05px",
                transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
                textDecoration: "none",
                display: "block",
              },
              hoverStyles: {
                transform: "translateY(-5px)",
              },
              responsiveStyles: {
                mobile: {
                  fontWeight: 700,
                },
              },
            },
            // Terms & Conditions
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Terms & Conditions",
              href: "/terms-and-conditions",
              styles: {
                color: "#FFF",
                textAlign: "center",
                fontFamily: "Roboto, sans-serif",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: 900,
                letterSpacing: "-1.05px",
                transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
                textDecoration: "none",
                display: "block",
              },
              hoverStyles: {
                transform: "translateY(-5px)",
              },
              responsiveStyles: {
                mobile: {
                  fontWeight: 700,
                },
              },
            },
            // Disclaimer
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Disclaimer",
              href: "/disclaimer",
              styles: {
                color: "#FFF",
                textAlign: "center",
                fontFamily: "Roboto, sans-serif",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: 900,
                letterSpacing: "-1.05px",
                transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
                textDecoration: "none",
                display: "block",
              },
              hoverStyles: {
                transform: "translateY(-5px)",
              },
              responsiveStyles: {
                mobile: {
                  fontWeight: 700,
                },
              },
            },
            // Product Label (trigger, not a link)
            {
              id: generateId(),
              type: "button" as ElementType,
              content: "Product Label",
              // href: "#product-label",
              styles: {
                color: "#FFF",
                textAlign: "center",
                fontFamily: "Roboto, sans-serif",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: 900,
                letterSpacing: "-1.05px",
                transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
                textDecoration: "none",
                display: "block",
                cursor: "pointer",
              },
              hoverStyles: {
                transform: "translateY(-5px)",
              },
              responsiveStyles: {
                mobile: {
                  fontWeight: 700,
                },
              },
              triggerPopup:"fortigold-label-popup",
              // You can add a custom property for JS trigger if needed
            },
            // Returns & Refunds
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Returns & Refunds",
              href: "/returns-and-refunds",
              styles: {
                color: "#FFF",
                textAlign: "center",
                fontFamily: "Roboto, sans-serif",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: 900,
                letterSpacing: "-1.05px",
                transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
                textDecoration: "none",
                display: "block",
              },
              hoverStyles: {
                transform: "translateY(-5px)",
              },
              responsiveStyles: {
                mobile: {
                  fontWeight: 700,
                },
              },
            },
            // Contact
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Contact",
              href: "/contact-us",
              styles: {
                color: "#FFF",
                textAlign: "center",
                fontFamily: "Roboto, sans-serif",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: 900,
                letterSpacing: "-1.05px",
                transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
                textDecoration: "none",
                display: "block",
              },
              hoverStyles: {
                transform: "translateY(-5px)",
              },
              responsiveStyles: {
                mobile: {
                  fontWeight: 700,
                },
              },
            },
          ],
        },
      ],
    },
  ],
});

const createFooterEndSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    backgroundColor: "#fff",
    margin: 0,
    padding: 0,
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "1200px",
        margin: "0 auto",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: "12px",
        padding: "60px 0 0",
      },
      responsiveStyles: {
        mobile: {
          padding: "0 15px",
          margin: "30px auto 0",
        },
      },
      children: [
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content:
            "These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease. The information presented on this site is for informational purposes only and is not a substitute for advice from your physician or other healthcare professional. Always consult with a qualified healthcare provider before beginning any diet, supplement, or exercise program.",
          styles: {
            textAlign: "center",
            color: "rgba(0, 0, 0, 0.60)",
            fontFamily: "Poppins, sans-serif",
            fontSize: "24px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "28px",
            letterSpacing: "-0.28px",
          },
          responsiveStyles: {
            mobile: {
              fontSize: "16px",
            },
          },
        },
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content:
            "Individual results may vary. Testimonials and reviews appearing on this site reflect real-life experiences of individuals who used our products. However, results may not be typical and are not guaranteed.",
          styles: {
            textAlign: "center",
            color: "rgba(0, 0, 0, 0.60)",
            fontFamily: "Poppins, sans-serif",
            fontSize: "24px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "28px",
            letterSpacing: "-0.28px",
          },
          responsiveStyles: {
            mobile: {
              fontSize: "16px",
            },
          },
        },
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content: "Copyright © 2024 – 2025 FortiGold. All Rights Reserved.",
          styles: {
            padding: "30px 0",
            color: "rgba(0, 0, 0, 0.60)",
            textAlign: "center",
            fontFamily: "Poppins, sans-serif",
            fontSize: "22px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "45px",
            letterSpacing: "-0.22px",
          },
          responsiveStyles: {
            tablet: {
              padding: "10px 0",
              fontSize: "12px",
            },
            mobile: {
              padding: "10px 0",
              fontSize: "12px",
            },
          },
        },
      ],
    },
  ],
});

export const template1contactUs = (
  globalConfig: GlobalConfig,
  vslShowHide?: boolean
) => {
  return {
    contactUsSection: createContactUsSection(globalConfig),
    fortigoldFAQSection: createFortigoldFAQSection(globalConfig, vslShowHide),
    footerMenuSection: createFooterMenuSection(globalConfig),
    footerEndSection: createFooterEndSection(globalConfig),
  };
};
